/*
 * The 2627 pre-order free beanie offer has ended (all boards are in stock).
 * This script no longer adds a beanie to the cart.
 *
 * Cleanup only: if a shopper's cart still has the old auto-added beanie
 * (a Cuff Fold Beanie line tagged _free_gift = 2627-preorder-bonus) from
 * before the offer ended, remove it once so they aren't charged for a
 * beanie they didn't choose. Beanies added on purpose have no tag and
 * are never touched.
 */
(function () {
  var KEY = '_free_gift';
  var VALUE = '2627-preorder-bonus';

  function cleanup() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = (cart.items || []).find(function (item) {
          return item.properties && item.properties[KEY] === VALUE;
        });
        if (!line) return;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanup);
  } else {
    cleanup();
  }
})();
